import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import { MenuListDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import {
    ActionMenu,
    ActionMenuItem,
    Button,
    CircleIcon,
    EditIcon,
    IconButton,
    ImageIcon,
    MoreIcon,
    TuneIcon,
} from "shared/ui";

import {
    Actions,
    Body,
    Card,
    Counters,
    Cover,
    CoverImage,
    CoverPlaceholder,
    Logo,
    Name,
    Spacer,
} from "./styles";

interface MenuCardProps {
    menu: MenuListDto;
    locale: string;
}

export const MenuCard = ({ menu, locale }: MenuCardProps) => {
    const history = useHistory();

    const [actionsAnchorEl, setActionsAnchorEl] = useState<HTMLElement | null>(null);

    const actions: ActionMenuItem[] = [
        {
            key: "iiko",
            label: "Интеграция с iiko",
            onClick: () => history.push(`/menus/regular/settings/${menu.id}/iiko`),
        },
    ];

    return (
        <Card>
            <Cover>
                {menu.photos.backgroundPhotoUrl ? (
                    <CoverImage src={menu.photos.backgroundPhotoUrl} alt="" />
                ) : (
                    <CoverPlaceholder>
                        <ImageIcon />
                        Обложка не задана
                    </CoverPlaceholder>
                )}

                <Logo>
                    {menu.photos.logoPhotoUrl ? (
                        <img src={menu.photos.logoPhotoUrl} alt="" />
                    ) : (
                        <CircleIcon />
                    )}
                </Logo>
            </Cover>

            <Body>
                <Name>{localizedText(menu.name, locale)}</Name>
                <Counters>
                    <span>Категории: {menu.categoriesCount} шт.</span>
                    <span>Позиции: {menu.itemsCount} шт.</span>
                </Counters>
            </Body>

            <Actions>
                <Button
                    variant="contained"
                    onClick={() => history.push(`/menus/regular/${menu.id}/view`)}
                >
                    <EditIcon />
                    Позиции
                </Button>
                <Button
                    variant="outlined"
                    color="neutral"
                    onClick={() => history.push(`/menus/regular/settings/${menu.id}`)}
                >
                    <TuneIcon />
                    Настройки
                </Button>

                <Spacer />

                <IconButton
                    label="Ещё"
                    size="large"
                    onClick={(event) => setActionsAnchorEl(event.currentTarget)}
                >
                    <MoreIcon />
                </IconButton>
            </Actions>

            <ActionMenu
                open={!!actionsAnchorEl}
                anchorEl={actionsAnchorEl}
                title={localizedText(menu.name, locale)}
                items={actions}
                onClose={() => setActionsAnchorEl(null)}
            />
        </Card>
    );
};
